import React, {useEffect, useLayoutEffect, useRef, useState} from "react";
import ReactEChartsCore from "echarts-for-react/lib/core";
import * as echarts from "echarts/core";
import {BarChart, EffectScatterChart, GaugeChart, LineChart, PieChart, CustomChart} from "echarts/charts";
import {GridComponent, LegendComponent, TitleComponent, TooltipComponent, DataZoomComponent} from "echarts/components";
import {CanvasRenderer} from "echarts/renderers";

echarts.use([
    BarChart,
    EffectScatterChart,
    GaugeChart,
    PieChart,
    LineChart,
    GridComponent,
    LegendComponent,
    TitleComponent,
    TooltipComponent,
    DataZoomComponent,
    CanvasRenderer,
    CustomChart
]);

const CHART_STYLE = {height: "100%", width: "100%"};
const CHART_OPTS = {renderer: "canvas"};
const EMPTY_OPTION = {};

const readSize = (el) => {
    const rect = el.getBoundingClientRect();
    return {width: Math.round(rect.width), height: Math.round(rect.height)};
};

const SentryEchart = ({className = "", title, titleClass, height = "100%", style = {}, option, ...props}) => {
    const chartRef = useRef(null);
    const boxRef = useRef(null);
    const [size, setSize] = useState(null);

    const isFactory = typeof option === "function";

    useEffect(() => {
        const box = boxRef.current;
        if (!box) return;

        let rafId = null;
        const observer = new ResizeObserver(() => {
            if (rafId !== null) return;
            rafId = requestAnimationFrame(() => {
                rafId = null;
                setSize((prev) => {
                    const next = readSize(box);
                    return prev && prev.width === next.width && prev.height === next.height ? prev : next;
                });
                chartRef.current?.getEchartsInstance?.().resize();
            });
        });

        observer.observe(box);

        return () => {
            observer.disconnect();
            if (rafId !== null) cancelAnimationFrame(rafId);
        };
    }, []);

    const resolvedOption = isFactory ? (size ? option(size) : EMPTY_OPTION) : option;

    return (
        <div
            className={["flex flex-col overflow-hidden", className].filter(Boolean).join(" ")}
            style={{height, minHeight: 0, ...style}}
        >
            {
                title &&
                <h3 className={["text-center mb-1.5! text-(length:--font-md)! shrink-0 text-[#AAAAAA]", titleClass].filter(Boolean).join(" ")}>{title}</h3>
            }

            <div ref={boxRef} className="flex-1 min-h-0 w-full">
                <ReactEChartsCore
                    ref={chartRef}
                    echarts={echarts}
                    style={CHART_STYLE}
                    opts={CHART_OPTS}
                    notMerge={false}
                    lazyUpdate={true}
                    option={resolvedOption}
                    {...props}
                />
            </div>
        </div>
    );
};

export default SentryEchart;
